import { ENVIRONMENT_CONTEXT, ENVIRONMENT_NAME } from 'config/env';

export const environmentLabelFooter = [ENVIRONMENT_NAME, ENVIRONMENT_CONTEXT].filter(Boolean).join(' ') || undefined;
